import React from "react"
import { connect } from 'react-redux'
import Image from "./image";
import {LogoIcon} from "./icons";
import { ga4 } from '../handlers/google-analytic'

const handleMyPriviledge = (categoryName, profileId) => {
  ga4.gtag("event", "my_privilege_category", {
    category_name: categoryName,
    category: 'my_privilege',
    trigger: `my_privilege_${categoryName}_btn`,
    profile_id: profileId
  })
}

class CategoryHome extends React.Component {
  state = {
    selected: {}
  }

  componentDidMount() {
    this.setState({
      selected: this.props.defaultSelected
    })
  }

  setSelectedCategory(category) {
    handleMyPriviledge(category.label, this.props.profileId)
    this.setState({
      selected: category
    }, () => {
      this.props.onClickItem(category)
    })
  }

  render() {
    const { iconMode, data = [], className = '' } = this.props

    return (
      <div className={`category-home ${className}`}>
        <ul>
          {
            data.map(item => (
              <li key={ item.key }
                  className={ iconMode ? 'category-item-icon-mode' : `category-item ${ item.categoryCode === this.state.selected.categoryCode ? 'category-item-active' : ''}`}
                  onClick={() => this.setSelectedCategory(item)}
                  button_id={`my_privilege_${item.label}_btn`}
              >
                {
                  iconMode &&
                  <Image PlaceholderComponent={
                    <div
                      className={'coupon-wisdom-logo-box with-placeholder'}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <LogoIcon svg={{ height: '1.5em', className: 'coupon-wisdom-logo' }}/>
                    </div>}
                      src={item.image}
                  />
                }
                <div>{ item.label }</div>
              </li>
            ))
          }
        </ul>
      </div>
    )
  }
}

const mapStateToProps = ({ user }) => {
  return {
  profileId: user.profileId,
}}

export default connect(mapStateToProps)(CategoryHome)
